import {
  IFeatureAppHomePageQuery,
  IFeatureWebHomePageQuery,
  useFeatureAppHomePageQuery,
  useFeatureWebHomePageQuery,
} from 'generated/sanity-graphql';
import { isNative } from 'utils/environment';

export type IFeatureHomePageQuery = IFeatureAppHomePageQuery | IFeatureWebHomePageQuery;

export const useFeatureHomePageQuery = isNative
  ? useFeatureAppHomePageQuery
  : useFeatureWebHomePageQuery;
